import React from 'react';
import PropTypes from 'prop-types';
import WizardInput from '../Input';
import Input from '../../Input';
import styles from './styles.less';

const Mailer = ({ t, email, setValue }) => (
  <>
    <WizardInput title={t('course.create.wizard.step5_2')} hint={t('wizard.hint.email')}>
      <Input
        version="long"
        size="large"
        defaultValue={email}
        value={email}
        onChange={e => setValue(e.target.value, 'email')}
        placeholder={t('course.create.wizard.mail.input.text')}
        className={styles.mailer}
        name="wizard_input_email"
      />
    </WizardInput>
  </>
);

Mailer.propTypes = {
  setValue: PropTypes.func,
  t: PropTypes.func,
  email: PropTypes.string,
};

Mailer.defaultProps = {
  setValue: () => {},
  t: () => {},
  email: '',
};

export default Mailer;
